import React from 'react';

import IconButton from '../icon-button/icon-button';

import './styles.scss';

export default function PoliciesPanel({ country, policyType, onClickBack, children }) {
  return (
    <div className="policies-panel">
      <div className="policies-panel__header">
        <h1>{country.model.name}</h1>
        {onClickBack ? <IconButton icon="close" handleClick={onClickBack} /> : null}
      </div>
      {policyType && policyType.model.description ? (
        <div
          className="policies-panel__subheader"
          dangerouslySetInnerHTML={{ __html: policyType.model.description }}
        />
      ) : null}
      <div className="policies-panel__body">{children}</div>
    </div>
  );
}
